<template>
    <component
        :is="showAsLink ? NuxtLink : 'span'"
        v-if="productionHouse?.name"
        v-bind="showAsLink ? { to } : {}"
        class="event-artist"
    >
        <span>
            {{ productionHouse.name }}
        </span>

        {{ withComma ? ',' : '' }}
    </component>
</template>

<script setup lang="ts">
const props = withDefaults(
    defineProps<{
        productionHouse: ProductionHouseRelation | null;
        withComma?: boolean;
    }>(),
    {
        withComma: false,
    }
);

const NuxtLink = resolveComponent('NuxtLink');

const route = useRoute();

const showAsLink = computed(() =>
    !!props.productionHouse?.slug
    && route.params.slug !== props.productionHouse.slug
);

const to = computed(() =>
    showAsLink.value ? `/productie-huis/${props.productionHouse?.slug}` : null
);
</script>